import React from "react";
import { MapPin, Phone, Mail, Globe, User, Building2, FileText } from "lucide-react";

/**
 * Impressum-Seite
 * Enthält alle rechtlich erforderlichen Angaben gemäß TMG und RStV
 * Zeigt Informationen über den Betreiber, Kontaktdaten und Verantwortlichkeiten
 */
export default function Impressum() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0D5C63] via-[#1A7A85] to-[#2D9DA6] py-12">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Impressum
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Rechtliche Angaben gemäß § 5 DDG
          </p>
        </div>

        {/* Hauptinhalt */}
        <div className="bg-white rounded-xl shadow-2xl p-8 md:p-12">
          <div className="space-y-8">
            {/* Firmeninformationen */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                <Building2 className="mr-3 text-[#0D5C63]" />
                Kur- und Reiseverkehr Bad Tabarz kAöR
              </h2>
              <div className="space-y-2 text-gray-700">
                <p>Schwimmbadweg 10</p>
                <p>99891 Bad Tabarz</p>
                <p><strong>Handelsregister:</strong> HRA 506788</p>
                <p><strong>Registergericht:</strong> AG Jena</p>
              </div>
            </section>

            {/* Vertretung */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3 flex items-center">
                <User className="mr-2 text-[#0D5C63]" />
                Vertreten durch:
              </h3>
              <div className="space-y-1 text-gray-700">
                <p>Wiebke M. Göring (1. Vorstand)</p>
                <p>Thomas Fröhlich (2. Vorstand)</p>
              </div>
            </section>

            {/* Kontakt */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3 flex items-center">
                <Phone className="mr-2 text-[#0D5C63]" />
                Kontakt
              </h3>
              <div className="space-y-2 text-gray-700">
                <p><strong>Telefon:</strong> 036259 5600</p>
                <p><strong>Telefax:</strong> 036259 67375</p>
                <p><strong>E-Mail:</strong> 
                  <a href="mailto:info@bad-tabarz.de" className="text-[#0D5C63] hover:underline ml-1">
                    info@bad-tabarz.de
                  </a>
                </p>
              </div>
            </section>

            {/* Fotos */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3 flex items-center">
                <FileText className="mr-2 text-[#0D5C63]" />
                Fotos
              </h3>
              <p className="text-gray-700">Kur- und Reiseverkehr Bad Tabarz kAöR</p>
            </section>

            {/* Umsatzsteuer-ID */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Umsatzsteuer-ID
              </h3>
              <p className="text-gray-700">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
              </p>
              <p className="text-gray-700 font-mono text-lg mt-1">DE235302305</p>
            </section>

            {/* Redaktionell verantwortlich */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Redaktionell verantwortlich
              </h3>
              <div className="space-y-1 text-gray-700">
                <p>Kur- und Reiseverkehr Bad Tabarz kAöR</p>
                <p>Schwimmbadweg 10</p>
                <p>99891 Bad Tabarz</p>
              </div>
            </section>

            {/* EU-Streitschlichtung */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                EU-Streitschlichtung
              </h3>
              <p className="text-gray-700 mb-2">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#0D5C63] hover:underline ml-1"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="text-gray-700">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            </section>

            {/* Verbraucherschlichtungsstelle */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Verbraucherschlichtungsstelle/Universalschlichtungsstelle
              </h3>
              <p className="text-gray-700">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            {/* Haftung für Inhalte */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Haftung für Inhalte
              </h3>
              <div className="space-y-3 text-gray-700 text-sm">
                <p>
                  Gemäß § 7 TMG sind Dienstanbieter für eigene Informationen, die sie zur Nutzung bereithalten nach den allgemeinen Gesetzen verantwortlich.
                </p>
                <p>
                  Dienstanbieter sind gemäß §§ 8 bis 10 TMG nicht für fremde Informationen, welche sie in einem Kommunikationsnetz übermitteln, verantwortlich. Sie sind auch nicht verpflichtet übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach rechtswidrigen Tatbeständen zu forschen.
                </p>
                <p>
                  Die Verpflichtung zur Sperrung und Löschung solcher Informationen, nach den allgemeinen gesetzlichen Grundlagen, bleibt unberührt. Eine Haftung kann erst nach Kenntniserlangung einer konkreten Rechtsverletzung geltend gemacht werden. Eine Löschung erfolgt umgehend nach Bekanntwerden der Rechtsverletzung.
                </p>
              </div>
            </section>

            {/* Haftung für Links */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Haftung für Links
              </h3>
              <div className="space-y-3 text-gray-700 text-sm">
                <p>
                  Unsere Website enthält Links zu Websites externer Dritter. Auf die Inhalte der Websites Dritter haben wir keinen Einfluss. Wir können daher auch keine Gewähr für den Inhalt dieser Websites externer Dritter übernehmen. Der jeweilige Betreiber oder Anbieter ist für die Inhalte der verlinkten Seiten verantwortlich. Zum Zeitpunkt der Verlinkung wurden die Seiten auf mögliche Rechtsverstöße geprüft. Zu diesem Zeitpunkt waren keine rechtswidrigen Inhalte erkennbar.
                </p>
                <p>
                  Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>
            </section>

            {/* Urheberrecht */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Urheberrecht
              </h3>
              <div className="space-y-3 text-gray-700 text-sm">
                <p>
                  Alle durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                </p>
                <p>
                  Urheberrechte Dritter werden beachtet, soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden. Inhalte Dritter werden als solche gekennzeichnet. Wir bitten um entsprechenden Hinweis, wenn Sie auf eine Urheberrechtsverletzung aufmerksam werden. Sobald ein Verstoß bekannt wird, werden wir derartige Inhalte entfernen.
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
